import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h2", { class: "font-semibold text-xl text-gray-800 leading-tight" }, " まとめ買い模試追加 ", -1);
const _hoisted_2 = { class: "max-w-7xl mx-auto py-6 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "shadow-lg bg-white rounded-lg p-6" };
const _hoisted_4 = { class: "grid grid-cols-12 mb-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-3 pt-2 pr-4 text-right",
    for: "title"
}, [
    /*#__PURE__*/ _createTextVNode(" まとめ買い名"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-red-500" }, "*")
], -1);
const _hoisted_6 = { class: "col-span-9" };
const _hoisted_7 = { class: "grid grid-cols-12 mb-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-3 pt-2 pr-4 text-right",
    for: "bundle_price_id"
}, " Stripeセット価格 ", -1);
const _hoisted_9 = { class: "col-span-9" };
const _hoisted_10 = { class: "grid grid-cols-12 mb-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "col-span-3 pt-2 pr-4 text-right" }, [
    /*#__PURE__*/ _createElementVNode("label", { for: "examinations" })
], -1);
const _hoisted_12 = { class: "col-span-9" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg mb-3" }, "選択可能な模試一覧", -1);
const _hoisted_14 = {
    key: 0,
    class: "text-red-400"
};
const _hoisted_15 = {
    key: 1,
    class: "rounded p-4"
};
const _hoisted_16 = ["id", "value"];
const _hoisted_17 = ["for"];
const _hoisted_18 = { class: "flex items-center justify-end px-4 py-3 bg-gray-50 text-right shadow rounded-b-lg" };
const _hoisted_19 = ["disabled"];
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "mr-3 flex-1" }, null, -1);
const _hoisted_21 = ["disabled", "onClick"];
import { Inertia } from '@inertiajs/inertia';
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import InputError from '@/Jetstream/InputError.vue';
// @ts-ignore
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    props: {
        examinations: {
            type: Array,
            default: () => [],
        },
        currentExaminationId: {
            type: String,
            default: '',
        },
        currentExaminationType: {
            type: String,
            default: '',
        },
    },
    setup(__props) {
        const props = __props;
        // フォームデータ（必要な項目のみ）
        const form = useForm({
            title: '',
            bundle_price_id: '',
            selected_examinations: [],
        });
        // 戻るボタン
        const onReturnClicked = () => {
            Inertia.get(route('bulk_purchase.index', {
                examinationId: props.currentExaminationId,
                examinationType: props.currentExaminationType,
            }));
        };
        // 送信処理
        function onSubmit() {
            form.post(route('bulk_purchase.store'));
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppLayout, { title: "新規まとめ買い模試追加" }, {
                header: _withCtx(() => [
                    _hoisted_1
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "title",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).title) = $event)),
                                        type: "text",
                                        class: "w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        placeholder: "まとめ買い名を入力してください"
                                    }, null, 512), [
                                        [_vModelText, _unref(form).title]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.title,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "bundle_price_id",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).bundle_price_id) = $event)),
                                        type: "text",
                                        class: "w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        placeholder: "セット販売用のStripe価格IDを入力"
                                    }, null, 512), [
                                        [_vModelText, _unref(form).bundle_price_id]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.bundle_price_id,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    (props.examinations.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 選択できる模試がありません "))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.examinations, (exam) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: exam.id,
                                                    class: "flex items-center mb-2 pb-2"
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: `exam_${exam.id}`,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).selected_examinations) = $event)),
                                                        type: "checkbox",
                                                        value: exam.id,
                                                        class: "mr-2"
                                                    }, null, 8, _hoisted_16), [
                                                        [_vModelCheckbox, _unref(form).selected_examinations]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: `exam_${exam.id}`,
                                                        class: "flex-grow"
                                                    }, _toDisplayString(exam.title), 9, _hoisted_17)
                                                ]));
                                            }), 128)),
                                            _createVNode(InputError, {
                                                message: _unref(form).errors.selected_examinations,
                                                class: "mt-2"
                                            }, null, 8, ["message"])
                                        ]))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded border border-blue-600 text-blue-600 max-w-max shadow-sm hover:shadow-lg"]),
                                disabled: _unref(form).processing,
                                onClick: onReturnClicked
                            }, " 戻る ", 10, _hoisted_19),
                            _hoisted_20,
                            _createElementVNode("button", {
                                class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                disabled: _unref(form).processing,
                                onClick: _withModifiers(onSubmit, ["prevent"])
                            }, " 登録 ", 10, _hoisted_21)
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
